//
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col, Divider, Icon, Button, Input, DatePicker, Select, TimePicker, message, Modal } from 'antd';
import moment from 'moment';
import Papa from 'papaparse';

// Actions
import { 
    get_expense_reports, 
    get_initial_users } from './actions/expense.action';

let timer,x;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const dateFormat = 'YYYY/MM/DD';
const timeFormat = 'HH:mm';
const confirm = Modal.confirm;
class ExpenseReports extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            filtered_data: [],
            users_list: [],
            user: '',
            start_date: '',
            end_date: ''
        }

        this.handleDateFilters = this.handleDateFilters.bind( this );
        this.handleUserFilter = this.handleUserFilter.bind( this );
        this.handleDownload = this.handleDownload.bind( this );

    }

    handleDownload(){
        alert( 'Not Done' );
    }

    handleUserFilter(){

    }

    handleDateFilters(){

    }

    componentWillReceiveProps( nextProps ){
        if( nextProps.hr_meetings.length !== 0 ){

            if( nextProps.hr_meetings.STATUS.CODE === "200" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Listed Expenses" ){

                this.setState({
                    data: nextProps.hr_meetings.OUTPUT.DATA
                });
            }

            if( nextProps.hr_meetings.STATUS.CODE === "200" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Listed Users" ){

                this.setState({
                    users_list: nextProps.hr_meetings.OUTPUT.DATA
                });
            }

        }
    }

    componentWillMount(){

        if( this.props.match.params.start_date &&
            this.props.match.params.end_date &&
            this.props.match.params.user ){

            this.setState({
                user: this.props.match.params.user,
                start_date: this.props.match.params.start_date,
                end_date: this.props.match.params.end_date
            })
    
            this.props.get_initial_users();
            this.props.get_expense_reports( this.props.match.params.start_date, this.props.match.params.end_date, this.props.match.params.user );
            this.props.history.push( '/hr-reports/expense/' + this.props.match.params.start_date +'/'+ this.props.match.params.end_date + '/' + this.props.match.params.user );

        } else {

            const start_date = moment().clone().startOf('month').format('YYYY-MM-DD');
            const end_date = moment().clone().endOf('month').format('YYYY-MM-DD');
        
            this.setState({
                user: 'all',
                start_date: start_date,
                end_date: end_date
            })
    
            this.props.get_initial_users();
            this.props.get_expense_reports( start_date, end_date, 'all' );
            this.props.history.push( '/hr-reports/expense/' + start_date +'/'+ end_date+ '/all' );

        }
        

    }

    render() {

        const columns = [
            {
                title: 'Employee',
                dataIndex: 'full_name',
                key: 'full_name',
            },{
                title: 'Date',
                dataIndex: 'exp_date',
                key: 'exp_date',
            },{
                title: 'Description',
                dataIndex: 'exp_description',
                key: 'exp_description',
            },{
                title: 'Amount',
                dataIndex: 'exp_amount',
                key: 'exp_amount',
            },{
                title: 'Currency',
                dataIndex: 'exp_currency',
                key: 'exp_currency',
            },{
                title: 'Currency Rate',
                dataIndex: 'exp_currency_rate',
                key: 'exp_currency_rate',
            },{
                title: 'Amount AED',
                dataIndex: 'amount_aed',
                key: 'amount_aed',
            }
        ]


        const users_list = this.state.users_list.map( ( item, k ) => <Option value={ item.user_id }>{ item.full_name }</Option> )

        return (
            <div>
                <Row gutter={16}>
                    <Col span={6}>
                        <h2>
                            <Icon type="snippets" />
                            &nbsp; Expense
                        </h2>
                    </Col>
                    <Col span={18}>

                        <span className="filter-wrapper">
                            <b>Filters</b> &nbsp;&nbsp;
                            <RangePicker 
                                onChange={ this.handleDateFilters }/>&nbsp;&nbsp;
                            <Select 
                                placeholder="Select Employee"
                                style={{ width: '150px' }}
                                defaultValue={ this.state.user }
                                onChange={ this.handleUserFilter }>
                                <Option value="all">All</Option>
                                { users_list }
                            </Select>
                            <Button
                                style={{ marginLeft: '10px' }}
                                onClick={ this.handleDownload }
                                icon="download"
                                className="fl_right">Download</Button>
                        </span>

                            
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col>
                        <Table
                            columns={ columns } 
                            dataSource={ this.state.data } />
                    </Col>
                </Row>
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        hr_meetings: state.hr_meetings
    }
}

export default connect( mapStatetoProps, { 
    get_expense_reports,
    get_initial_users })( ExpenseReports );



// WEBPACK FOOTER //
// ./src/pages/hr-reports/expense/index.js